import { render, staticRenderFns } from "./SellerProductStatistic.vue?vue&type=template&id=1f32c700&scoped=true"
import script from "./SellerProductStatistic.vue?vue&type=script&lang=js"
export * from "./SellerProductStatistic.vue?vue&type=script&lang=js"
import style0 from "./SellerProductStatistic.vue?vue&type=style&index=0&id=1f32c700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f32c700",
  null
  
)

export default component.exports